import type { InstagramConnectionOutcome } from "../../api/gen/model";
import { isOneOf, textOf } from "../../search";

const outcomes: Record<InstagramConnectionOutcome, true> = {
  connected: true,
  free_already_consumed: true,
  denied: true,
  expired: true,
  personal_account: true,
  permissions_missing: true,
  account_in_use: true,
  another_account_connected: true,
  refused: true,
  unavailable: true,
  failed: true,
};

export type OutcomeSearch = { instagram?: InstagramConnectionOutcome; holder?: string };

// Kept in memory once read: the page takes the address's search away as it shows the outcome.
let holder: string | undefined;

/** The masked address of the workspace the last account in use publishes for, if the callback named it. */
export function heldBy(): string | undefined {
  return holder;
}

/** The outcome a connection to Instagram came back with, if the address carries one, and the masked address of the
 * workspace an account in use publishes for. */
export function validateOutcomeSearch(search: Record<string, unknown>): OutcomeSearch {
  const outcome = search["instagram"];
  if (!isOneOf(outcomes, outcome)) {
    return {};
  }
  const named = textOf(search["holder"]);
  if (outcome !== "account_in_use" || named === undefined) {
    return { instagram: outcome };
  }
  holder = named;
  return { instagram: outcome, holder: named };
}
